<div class="col-md-9 pl-0 row d-flex align-items-center" style="cursor: pointer;color:rgb(75, 197, 238);">
    <u (click)="handleBack()" *ngIf="letterType === 'COVLTR'">
        <span class="material-icons align-middle" style="font-size:inherit;">
            arrow_back_ios
        </span>Create Own Letter
    </u>
</div>

<div class="row col-md-12 p-0">
    <p class="letter-hint d-flex align-items-center">
        <span style="padding-top: 3px;" class="pi pi-exclamation-triangle"> </span>
        If you have modified the template you used, You need to 'Generate the Letter' again to sync the changes.
    </p>
</div>

<div class="letter-list">
    <form #letterTemplateForm="ngForm">
        <p-table [columns]="listTemplateColumns"
            class="pa-table im-card-no-border-table im-card-table-noborder-spacing table"
            styleClass="p-datatable-gridlines" [value]="templateList" dataKey="id" (onRowExpand)="onRowExpand($event)">
            <ng-template pTemplate="header" let-columns>
                <tr class="text-uppercase">
                    <th style="width: 2rem"></th>
                    <th *ngFor="let col of columns">
                        {{col.header}}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-listData let-expanded="expanded" let-columns="columns">
                <tr>
                    <td style="padding: 10px 0px !important">
                        <button type="button" pButton pRipple [pRowToggler]="listData"
                            class="p-button-text p-button-rounded p-button-plain"
                            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                    </td>
                    <td *ngFor="let col of columns" class="text-truncate">
                        <span *ngIf="col.field != 'isDefault' && col.field !== 'templateName'"> {{listData[col.field]}}
                        </span>
                        <span *ngIf="col.field === 'templateName'">
                            <span>{{listData['templateName']}} </span>
                        </span>

                        <span *ngIf="col.field == 'isDefault'" class="column.customClass default-btn">
                            <p *ngIf="listData[col.field] === 'true'" class="m-0">
                                Default
                            </p>
                            <span *ngIf="listData['id'] === lastUsedTemplateId && isOwnTemplateUsed"
                                class="column.customClass last-text">
                                Last Used <br />Template
                            </span>
                        </span>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="rowexpansion" let-listData>
                <tr>
                    <td colspan="7">
                        <div class="sub-task-type pb-3">
                            <div class="row col-md-12">
                                <h6 class="label-cls">Template Name - </h6>
                                <div class="row pl-1"> {{listData['templateName']}}</div>
                            </div>
                            <div class="row col-md-12 d-flex align-items-center">
                                <div class="col-md-7 my-2 p-0 expand-text">Did you select 'Additional Info for
                                    {{letterType
                                    === 'COVLTR' ? 'Cover Letter' :'Support Letter'}}' in
                                    placeholder
                                    while
                                    creating the template? </div>
                                <div class="col-md-3 p-0 pl-1">
                                    <div (change)="handleToggle($event)" aria-labelledby="example-radio-group-label"
                                        class="example-radio-group">
                                        <p-radioButton class="example-radio-button" [(ngModel)]="additionalInfo"
                                            [disabled]="disabledControls" name="additionalInfo" value="Yes" class="pr-4"
                                            label="Yes">
                                        </p-radioButton>
                                        <p-radioButton class="example-radio-button" [(ngModel)]="additionalInfo"
                                            value="No" [disabled]="disabledControls" name="additionalInfo" label="No">
                                            <label for="No">No</label>
                                        </p-radioButton>
                                    </div>
                                </div>
                                <div class="col-md-2 preview-btn p-0" *ngIf="additionalInfo === 'No'">
                                    <button class="p-button-outlined" pButton label="PREVIEW" style="width:100%"
                                        type="button" [disabled]="disabledControls"
                                        (click)="handleSavePreview('Preview')"></button>
                                </div>
                            </div>
                            <div class="col-12 pt-3  letter-textarea" *ngIf="additionalInfo === 'Yes'">
                                <p class="pb-3 mb-0 one-liner expand-text">Add Additional Info for {{letterType ===
                                    'COVLTR'
                                    ? 'Cover Letter' :'Support Letter'}} <small style="font-size: 13px;">(placeholder
                                        added
                                        when creating this template)</small></p>
                                <!-- <textarea [(froalaModel)]="letterTextContent" name="letterTextContent"
                                    [froalaEditor]="options" ngModel></textarea> -->
                                <kendo-editor [(value)]="letterTextContent"
                                    (valueChange)="letterTextContenteditorValueChange($event)" #templatekendoeditor
                                    style="height: 400px;" name="letterTextContent">
                                    <kendo-toolbar>
                                        <kendo-toolbar-buttongroup>
                                            <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                                            <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                                            <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                                            <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                                        </kendo-toolbar-buttongroup>
                                        <kendo-toolbar-buttongroup>
                                            <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
                                            <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
                                        </kendo-toolbar-buttongroup>
                                        <kendo-toolbar-buttongroup>
                                            <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                                            <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                                            <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                                            <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                                        </kendo-toolbar-buttongroup>
                                        <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
                                        <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
                                        <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
                                        <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
                                        <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient">
                                        </kendo-toolbar-colorpicker>
                                        <kendo-toolbar-buttongroup>
                                            <kendo-toolbar-button kendoEditorInsertUnorderedListButton>
                                            </kendo-toolbar-button>
                                            <kendo-toolbar-button kendoEditorInsertOrderedListButton>
                                            </kendo-toolbar-button>
                                            <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                                            <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
                                        </kendo-toolbar-buttongroup>
                                        <kendo-toolbar-button kendoEditorBlockquoteButton></kendo-toolbar-button>
                                        <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button>
                                        <kendo-toolbar-buttongroup>
                                            <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
                                            <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
                                        </kendo-toolbar-buttongroup>
                                        <kendo-toolbar-buttongroup>
                                            <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                                            <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
                                        </kendo-toolbar-buttongroup>
                                        <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button>
                                        <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
                                        <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
                                        <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
                                        <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
                                        <kendo-toolbar-buttongroup>
                                            <kendo-toolbar-button kendoEditorAddColumnBeforeButton>
                                            </kendo-toolbar-button>
                                            <kendo-toolbar-button kendoEditorAddColumnAfterButton>
                                            </kendo-toolbar-button>
                                            <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
                                            <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
                                        </kendo-toolbar-buttongroup>
                                        <kendo-toolbar-buttongroup>
                                            <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
                                            <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
                                            <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
                                        </kendo-toolbar-buttongroup>
                                        <kendo-toolbar-buttongroup>
                                            <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
                                            <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
                                        </kendo-toolbar-buttongroup>
                                        <kendo-toolbar-button kendoEditorPrintButton></kendo-toolbar-button>
                                        <kendo-toolbar-buttongroup>
                                            <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
                                            <kendo-toolbar-button title="Upload’s Image at cursor point"
                                                text="Upload Image" (click)="templateimageuploaddialog()">
                                            </kendo-toolbar-button>
                                        </kendo-toolbar-buttongroup>

                                    </kendo-toolbar>
                                </kendo-editor>
                                <app-upload-image-dialog #templateimageupload [editor]="templatekendoeditor">
                                </app-upload-image-dialog>
                                <div class="d-flex py-2 pt-3">
                                    <div class="mr-3">
                                        <button type="button" pButton class="p-button-info"
                                            (click)="handleSavePreview('Save')">SAVE & PREVIEW</button>
                                    </div>
                                    <div>
                                        <button type="button" pButton class="p-button-info"
                                            (click)="handleSavePreview('Skip')">SKIP & PREVIEW</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <!-- <div *ngIf="templateList?.length == 0" class="mt-4 text-center">No Data</div> -->
        <p-paginator [rows]="recordsPerPage" [rowsPerPageOptions]="[25,50,100]"
            (onPageChange)="handlePageSettingsChange($event)"></p-paginator>
    </form>
</div>